import React from 'react';
import { useHistory } from 'react-router-dom';
import commonConstant from '../commonConstant';
import './HnwHomeButton.scss';

const HnwHomeButton = ({ className = '' }) => {
  const history = useHistory();

  const handleClick = () => {
    history.replace(commonConstant.pathHealthnWellness);
  };

  return (
    <button className={`hnw-home-button ${className}`.trim()} onClick={handleClick} aria-label="กลับหน้าหลัก">
      <img src="/images/home-icon.svg" alt="home" width="40" height="40" />
    </button>
  );
};

export default HnwHomeButton;
